// extracted by mini-css-extract-plugin
module.exports = {"alertListHeader":"AlertListHeader_alertListHeader__2Hsy0","separate":"AlertListHeader_separate__1SULJ","alertAmount":"AlertListHeader_alertAmount__2iuyC"};